import { css } from 'styled-components';

export const wrapper = () => css`
  min-width: 18rem;
`;

export const mainAction = () => css`
  flex: 1;
`;
